<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>账户别名</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="addOtherName(1)" icon="el-icon-plus" v-if="postList.addBtn">新增账户别名</el-button>
                <div class="main_header_btns">
                    <crm-upload obj="account_alias" :queryParams="queryParams"></crm-upload>
                    <!-- 设置子组件 调整列显示隐藏 顺序 -->
                    <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                @sort-change="changeSort"
                :max-height="this.$tableHeight"
                @header-dragend="changeColWidth"
                v-loading="loading"
                class="account_alias"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="item.prop == 'source_account_code'">
                                <span v-if="scope.row.source_account"> {{ scope.row.source_account.code }} </span>
                            </div>
                            <div v-else-if="item.prop == 'source_account_name'">
                                <span v-if="scope.row.source_account"> {{ scope.row.source_account.name }} </span>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="100" fixed="right">
                    <template slot-scope="scope" style="height: 100%">
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="addOtherName(2, scope.row)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="deleteLine(scope.row.id, 0)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="强制删除" placement="top-start">
                            <i class="el-icon-error" @click="deleteLine(scope.row.id, 1)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page.sync="page"
                    :page-size="row"
                    :total="total"
                ></el-pagination>
            </div>
            <!-- 新增别名 -->
            <el-dialog
                :close-on-click-modal="false"
                v-dialogDrag
                :title="title"
                :visible.sync="dialogFormVisible"
                width="500px"
                :modal="false"
                :append-to-body="true"
            >
                <el-form :model="rulesDialogForm" :rules="rulesDialog" ref="ruleForm" label-width="100px">
                    <el-form-item label="code" prop="code">
                        <el-input v-model="rulesDialogForm.code" placeholder="请输入代码" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="别名" prop="name">
                        <el-input v-model="rulesDialogForm.name" placeholder="请输入别名" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="源账户" prop="source_account_name">
                        <el-select
                            v-model="rulesDialogForm.source_account_name"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="请输入账户名称搜索"
                            :remote-method="remoteMethod"
                            :loading="parentLoading"
                            size="small"
                            clearable
                            style="width: 100%"
                            @change="nameChange"
                        >
                            <el-option v-for="item in parentOptions" :key="item.code" :label="item.name" :value="item.rid"> </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="验证状态：" prop="is_verification">
                        <vDropdown
                            model_key="is_verification"
                            model_name="请选择验证状态"
                            :model_value_default="rulesDialogForm.is_verification"
                            request_uri="accountAliasVerification"
                            select_value="value"
                            @onDropChange="onDropChange"
                            ref="is_verification_ref"
                        ></vDropdown>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addName('ruleForm')">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import { onReSize } from '../../../../../js/common';
import draggableList from '../../../../common/Drawer.vue';
import crmUpload from '../../../../common/Upload.vue';
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload
    },
    name: 'accountAliasComponent',
    data() {
        return {
            draggable: {
                data_name: 'account_alias'
            },
            tableData: [],
            colData: [],
            total: 0,
            page: 1,
            row: 25,
            sort: '', //排序参数
            data_name: '', //排序参数
            loading: true,
            dialogFormVisible: false,
            title: '', //表格输入框
            type: '', //区分是修改还是新增
            //弹窗内表单验证
            rulesDialogForm: {
                name: '',
                code: '',
                source_account_rid: '',
                source_account_name: '',
                is_verification: 3
            },
            rulesDialog: {
                name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
                is_verification: [{ required: true, message: '请选择验证状态', trigger: 'blur' }]
            },
            parentOptions: [],
            parentLoading: false,
            rowRid: '',
            postList1: {},
            queryParams: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    created() {
        this.postList1 = this.postList;
    },
    watch: {
        postList1: {
            handler(newValue, oldValue) {
                if (newValue.params) {
                    if (newValue.params.account_rid) {
                        this.account_rid = newValue.params.account_rid;
                        this.queryParams.account_rid = this.account_rid;
                        this.getList(0); //获取列表
                    } else {
                        this.account_rid = '';
                    }
                }
            },
            deep: true
        }
    },
    beforeMount() {
        //详情内调用不用本地存储的params
        if (!this.postList.params) {
            //列表页面调用 优先取本地存储
            var paramsList = JSON.parse(localStorage.getItem('paramsList'));
            if (paramsList['accountAlias_params']) {
                this.page = paramsList['accountAlias_params'].page;
                this.row = paramsList['accountAlias_params'].row;
                this.account_rid = paramsList['accountAlias_params'].account_rid;
                this.queryParams.account_rid = this.account_rid;
                // this.data_name = paramsList['accountAlias_params'].data_name;
                // this.sort = paramsList['accountAlias_params'].sort;
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.row = 10;
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        //账户搜索联动框
        nameChange(val) {
            this.rulesDialogForm.source_account_rid = val;
        },
        //账户名称远程搜索方法
        remoteMethod(query) {
            if (query !== '') {
                this.parentLoading = true;
                let params = {
                    name: query
                };
                this.$api
                    .searchAccounts(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.parentLoading = false;
                            this.parentOptions = res.data;
                        } else {
                            this.parentOptions = [];
                        }
                    })
                    .catch((error) => {});
            } else {
                this.parentLoading = false;
                this.parentOptions = [];
            }
        },
        //新增别名弹窗
        addOtherName(type, row) {
            //type == 1 时 新增 ==2时 修改别名
            this.type = type;
            if (type == 1) {
                this.rulesDialogForm.name = '';
                this.rulesDialogForm.code = '';
                this.rulesDialogForm.source_account_rid = '';
                this.rulesDialogForm.source_account_name = '';
                this.rulesDialogForm.is_verification = 3;
                this.title = '新增别名';
                this.dialogFormVisible = true;
            } else {
                this.rowRid = row.rid;
                this.title = '修改别名';
                this.dialogFormVisible = true;
                this.rulesDialogForm.name = row.name;
                this.rulesDialogForm.code = row.code;
                this.rulesDialogForm.is_verification = row.is_verification;
                if (row.source_account) {
                    this.rulesDialogForm.source_account_rid = row.source_account_rid;
                    this.rulesDialogForm.source_account_name = row.source_account.name;
                }
            }
        },
        //新增别名数据提交验证
        addName(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData();
                } else {
                    return false;
                }
            });
        },
        //提交数据
        submitData() {
            if (this.type == 1) {
                //新增别名
                let params = {
                    account_rid: this.postList.params.account_rid,
                    name: this.rulesDialogForm.name,
                    code: this.rulesDialogForm.code,
                    source_account_rid: this.rulesDialogForm.source_account_rid ? this.rulesDialogForm.source_account_rid : '',
                    is_verification: this.rulesDialogForm.is_verification
                };
                this.$api
                    .accountAliasInsert(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.dialogFormVisible = false;
                            this.rulesDialogForm = {
                                name: '', //名称
                                code: '',
                                source_account_rid: '',
                                source_account_name: '',
                                is_verification: 3
                            };
                            this.$message({
                                message: '新增成功！',
                                type: 'success'
                            });
                            this.getList(0); //获取别名列表
                        }
                    })
                    .catch((error) => {});
            } else {
                //修改别名
                let params = {
                    rid: this.rowRid,
                    name: this.rulesDialogForm.name,
                    code: this.rulesDialogForm.code,
                    source_account_rid: this.rulesDialogForm.source_account_rid ? this.rulesDialogForm.source_account_rid : '',
                    is_verification: this.rulesDialogForm.is_verification
                };
                this.$api
                    .accountAliasUpdate(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.dialogFormVisible = false;
                            this.rulesDialogForm = {
                                name: '', //名称
                                code: '',
                                source_account_rid: '',
                                source_account_name: '',
                                is_verification: 3
                            };
                            this.$message({
                                message: '修改成功！',
                                type: 'success'
                            });
                            this.getList(0); //获取别名列表
                        }
                    })
                    .catch((error) => {});
            }
        },
        //删除
        deleteLine(id, is_force) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox(messages, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    if (is_force) {
                        var deleteMethod = 'accountAliasForceDlete';
                    } else {
                        var deleteMethod = 'accountAliasDlete';
                    }

                    this.$api[deleteMethod](params)
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '删除成功',
                                    type: 'success'
                                });
                                this.getList(0); //获取别名列表
                            }
                        })
                        .catch((error) => {});
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('account_alias', this);
        },
        onDropChange(key, value) {
            this.rulesDialogForm[key] = value;
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).account_alias;
        },
        // 从后台获取数据,重新排序
        changeSort(val) {
            this.data_name = val.prop;
            if (val.order == 'ascending') {
                this.sort = 'asc';
            } else if (val.order == 'descending') {
                this.sort = 'desc';
            }
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['accountAlias_params']) {
                    newParamsList['accountAlias_params'].data_name = val.prop;
                    newParamsList['accountAlias_params'].sort = this.sort;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            if (this.sort !== '') {
                this.getList(0); //获取列表
            }
        },
        //获取列表数据
        getList(type_data, type) {
            if (type == 1) {
                this.page = 1;
            }
            var params = {
                page: this.page,
                row: this.row,
                account_rid: this.account_rid,
                is_export: type_data
            };
            //当点击 或者触发回车事件保存参数
            if (type == 1) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                newParamsList['accountAlias_params'] = params;
                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            }
            if (type_data == 0) {
                this.loading = true;
                this.$api
                    .accountAliasLists(params)
                    .then((res) => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.tableData = res.data.data;
                            this.total = res.data.total;
                            //判断当前搜素页面参数是否大于最后一页 大于的话取最后一页的参数存起来并用最后一页的参数请求
                            if (res.data.current_page > res.data.last_page) {
                                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                                newParamsList['accountAlias_params'].page = res.data.last_page;
                                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                                this.page = res.data.last_page;
                            }
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                    });
            }
        },
        // 点击分页当前页数
        currentChange(val) {
            this.page = val;
            //当分页发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['accountAlias_params']) {
                    newParamsList['accountAlias_params'].page = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        account_rid: this.account_rid,
                        sort: [this.data_name, this.sort]
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['accountAlias_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        // 切换每页条数
        sizeChange(val) {
            this.row = val;
            //当页数发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['accountAlias_params']) {
                    newParamsList['accountAlias_params'].row = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        account_rid: this.account_rid,
                        sort: [this.data_name, this.sort]
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['accountAlias_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        }
    }
};
</script>
<style lang="scss" scoped>
// 让“暂无数据”文本居中显示
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>